"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Map = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var css = _interopRequireWildcard(require("./Map.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Map used to show static maps using GoogleMaps API
 *
 * All HTML attributes are supported, and all unhandled props, including refs,
 * are forwarded to the root `Map` component.
 */
const Map = ({
  apiKey = '',
  center = '',
  format = 'PNG',
  height = 144,
  language = '',
  maptype = 'roadmap',
  markers = [],
  path = '',
  region = '',
  scale = 1,
  style = '',
  visible = '',
  width = 640,
  zoom = 10,
  ...otherProps
}) => (0, _pragma.createFelaElement)("img", _extends({
  alt: "Map",
  css: css.root,
  src: "https://maps.googleapis.com/maps/api/staticmap?center=".concat(center, "&zoom=").concat(zoom, "&size=").concat(width, "x").concat(height, "&scale=").concat(scale, "&format=").concat(format, "&maptype=").concat(maptype, "&language=").concat(language, "&region=").concat(region, "&style=").concat(style, "&path=").concat(path, "&visible=").concat(visible).concat(markers.reduce((acc, marker) => "".concat(acc, "&markers=").concat(marker), ''), "&key=").concat(apiKey)
}, otherProps));

exports.Map = Map;
Map.displayName = 'Map';
var _default = Map;
exports.default = _default;
//# sourceMappingURL=Map.js.map